<!-- your-component.vue-->
<template>
  <div :class="['phone-input-wrapper', classes, { filled: hasValue }]">
    <div class="phone-input-shell">
      <input
        :id="inputId"
        type="tel"
        :class="[
          'custom-text-field',
          'w-100',
          inputClasses,
          { 'input-error': !!error },
        ]"
        :value="value"
        :required="required"
        placeholder=" "
        :aria-invalid="!!error ? 'true' : 'false'"
        @input="handleInput"
        @focus="onFocus"
        @blur="onBlur"
      />
      <label :for="inputId" class="floating-label">
        {{ label || (isRequired ? "Phone Number *" : "Phone Number") }}
      </label>
    </div>
    <div
      class="text-danger invalid-feedback"
      style="display: block"
      v-if="error"
    >
      {{ error }}
    </div>
  </div>
</template>

<script>
export default {
  inheritAttrs: false,
  name: "phone-input",
  props: {
    isRequired: {
      type: Boolean,
      default() {
        return true
      },
    },
    classes: {
      type: String,
      default() {
        return ""
      },
    },
    inputClasses: {
      type: String,
      default() {
        return ""
      },
    },
    borderRadius: {
      type: Number,
    },
    required: {
      type: Boolean,
    },
    label: {
      type: String,
    },
    error: {
      type: String,
    },
    value: {
      type: String,
    },
    isEditing: Boolean,
  },
  emits: ["on-change"],
  data() {
    return {
      focused: false,
      inputId: `phone-input-${Math.random().toString(36).slice(2, 9)}`,
    }
  },
  computed: {
    hasValue() {
      return (
        this.value !== undefined &&
        this.value !== null &&
        `${this.value}` !== ""
      )
    },
  },
  methods: {
    handleInput(e) {
      const input = e.target
      const cursorPos = input.selectionStart
      const oldValue = input.value
      const digits = oldValue.replace(/\D/g, "").slice(0, 10)

      let formatted = digits
      if (digits.length > 6) {
        formatted = `(${digits.slice(0, 3)}) ${digits.slice(
          3,
          6
        )}-${digits.slice(6)}`
      } else if (digits.length > 3) {
        formatted = `(${digits.slice(0, 3)}) ${digits.slice(3)}`
      } else if (digits.length > 0) {
        formatted = `(${digits}`
      }

      input.value = formatted

      // Restore cursor: count digits before old cursor, place after same count in new value
      const digitsBeforeCursor = oldValue
        .slice(0, cursorPos)
        .replace(/\D/g, "").length
      let newCursor = 0
      let digitsSeen = 0
      for (let i = 0; i < formatted.length; i++) {
        if (/\d/.test(formatted[i])) digitsSeen++
        if (digitsSeen >= digitsBeforeCursor) {
          newCursor = i + 1
          break
        }
      }
      if (digitsBeforeCursor === 0) newCursor = 0
      input.setSelectionRange(newCursor, newCursor)

      this.$emit("on-change", formatted)
    },
    onFocus() {
      this.focused = true
    },
    onBlur() {
      this.focused = false
    },
  },
}
</script>

<style lang="scss" scoped>
.phone-input-wrapper {
  width: 100%;
  margin-bottom: 24px !important;
  padding: 12px 0;
}

.phone-input-shell {
  position: relative;
  width: 100%;
}

.custom-text-field {
  min-height: 48px;
  border-radius: 8px;
  border: 1px solid var(--Gray-300, #b0b9c9);
  background: var(--White, #fff);
  color: var(--Gray-900, #343946);
  padding: 10px 16px;
  cursor: text;
}

.custom-text-field:hover {
  border: 2px solid var(--Gray-500, #677690);
}

.custom-text-field:focus {
  border: 2px solid var(--gfb-blue-brand-500, #0095e2);
  box-shadow: none;
  outline: none;
}

.custom-text-field.input-error {
  border: 2px solid var(--Red-500, #e24646);
  box-shadow: none !important;
}

.custom-text-field.input-error:hover {
  border: 2px solid var(--Red-500, #e24646);
}

.floating-label {
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  padding: 0 4px;
  background: var(--White, #fff);
  color: var(--Gray-600, #525e77);
  font-size: 16px;
  font-weight: 400;
  line-height: 1;
  pointer-events: none;
  transition: top 0.15s ease, transform 0.15s ease, color 0.15s ease,
    font-size 0.15s ease;
}

.custom-text-field:focus + .floating-label {
  top: 0;
  transform: translateY(-50%);
  font-size: 12px;
  color: #0095e2 !important;
}

.custom-text-field.input-error + .floating-label {
  color: var(--Red-500, #e24646) !important;
}

.custom-text-field:not(:placeholder-shown) + .floating-label {
  top: 0;
  transform: translateY(-50%);
  font-size: 12px;
  color: var(--Gray-600, #525e77);
}

.invalid-feedback {
  color: #e24646 !important;
  font-size: 14px !important;
  margin-top: 15px;
}
</style>
